import { __decorate } from "tslib";
import { BrowserModule } from "@angular/platform-browser";
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, Injector, NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { ServerInterceptor } from "./shared/services/service-interceptor/server-interceptor.service";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { AppConfig } from "./app.config";
import { DashboardModule } from "./core/dashboard/dashboard.module";
import { LoginComponent } from "./core/login/login.component";
import { SharedModule } from "./shared/shared.module";
import { AppControllerService } from "./app-controller.service";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { WindowReference } from "./shared/classes/window-reference";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { NavModule } from "./core/nav/nav.module";
import { OAuthModule } from "angular-oauth2-oidc";
import { AuthService } from "./shared/services/auth/auth.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TreeModule } from "@ali-hm/angular-tree-component";
import { APP_BASE_HREF, PlatformLocation } from "@angular/common";
import { GlobalErrorHandler } from "./shared/classes/global-error-handler";
import { RefreshViewApplicationComponent } from "./core/refresh/refresh-view-application/refresh-view-application.component";
import { LandingPageComponent } from "./core/landing-page/landing-page.component";
import { LogoutComponent } from "./core/logout/logout.component";
export let AppInjector;
export let AppModule = class AppModule {
    injector;
    constructor(injector) {
        this.injector = injector;
        AppInjector = this.injector;
    }
    static ctorParameters = () => [
        { type: Injector }
    ];
};
AppModule = __decorate([
    NgModule({
        schemas: [CUSTOM_ELEMENTS_SCHEMA],
        declarations: [
            AppComponent,
            LoginComponent,
            RefreshViewApplicationComponent,
            LandingPageComponent,
            LogoutComponent
        ],
        imports: [
            BrowserModule,
            BrowserAnimationsModule,
            AppRoutingModule,
            AppRoutingModule,
            ServiceWorkerModule.register("ngsw-worker.js", { enabled: environment.production }),
            MatProgressSpinnerModule,
            MatDialogModule,
            MatInputModule,
            ReactiveFormsModule,
            MatIconModule,
            MatSidenavModule,
            MatToolbarModule,
            MatButtonModule,
            HttpClientModule,
            DashboardModule,
            SharedModule,
            MatBottomSheetModule,
            NavModule,
            OAuthModule.forRoot(),
            NgbModule,
            TreeModule
        ],
        providers: [
            // Providing these two services like this here is done for a reason.
            // The Http interceptor needs them and the config.json file needs the interceptor
            // When the config is fetched the http interceptor hasn't received the services yet (they arent loaded yet)
            AuthService,
            AppControllerService,
            { provide: HTTP_INTERCEPTORS, useClass: ServerInterceptor, multi: true },
            WindowReference,
            AppConfig,
            { provide: ErrorHandler, useClass: GlobalErrorHandler },
            {
                provide: APP_BASE_HREF,
                useFactory: (s) => s.getBaseHrefFromDOM(),
                deps: [PlatformLocation]
            }
        ],
        bootstrap: [AppComponent],
        exports: []
    })
], AppModule);
